import { render, staticRenderFns } from "./SupplierPreview.vue?vue&type=template&id=234690ce&scoped=true&"
import script from "./SupplierPreview.vue?vue&type=script&lang=js&"
export * from "./SupplierPreview.vue?vue&type=script&lang=js&"
import style0 from "./SupplierPreview.vue?vue&type=style&index=0&id=234690ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234690ce",
  null
  
)

export default component.exports